export const GREEN_SUCCESS = "#B4EA69";
export const RED_FAIL = "#F14A21";

// follows from app.css colors
export const style = getComputedStyle(document.body);
export const LIGHT_1 = style.getPropertyValue("--light-1");
export const LIGHT_2 = style.getPropertyValue("--light-2");
export const GREEN_1 = style.getPropertyValue("--green-1");
export const GREEN_1_transparent = GREEN_1 + "55";
export const GREEN_2 = style.getPropertyValue("--green-2");
export const DARK_1 = style.getPropertyValue("--dark-1");
export const DARK_2 = style.getPropertyValue("--dark-2");
export const DARK_3 = style.getPropertyValue("--dark-3");
